// import app from '@/main';
import type { ToastMessageOptions } from 'primevue/toast';

export const DEFAULT_ERROR_MESSAGE = 'Ошибка!';

export const parseError = (error: any = DEFAULT_ERROR_MESSAGE) => {
  const messages: string[] = [];
  const isNotJson = !(
    error.response.headers['content-type'] === 'application/json; charset=utf-8'
  );

  if (isNotJson || typeof error === 'string') {
    messages.push(error);
  } else {
    if (error.response.data.detail) {
      messages.push(error.response.data.detail);
    } else {
      Object.keys(error.response.data).forEach((key) => {
        const field = error.response.data[key];
        const fields = Array.isArray(field) ? field : [field];
        messages.push(...fields);
      });
    }
  }

  return messages;
};

let toastInstance: {
  add: (
    options: ToastMessageOptions & { summary: string; life?: number },
  ) => void;
} | null = null;

export const setToastInstance = (instance: typeof toastInstance) => {
  toastInstance = instance;
};

export const showToast = (
  message: string,
  severity: ToastMessageOptions['severity'] = 'error',
) => {
  if (toastInstance) {
    toastInstance.add({
      summary: message.replace(/\.$/, ''),
      severity,
      life: 6000,
    });
  }
};

export const displayError = (messages: string[]) => {
  messages.forEach((message) => showToast(message));
};
